import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

export default class BaseComponent extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        const response = shallowCompare(this, nextProps, nextState);
        return response;
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/BaseComponent.jsx
 **/